import { getCachedMediaUrl } from '../../../../../lib/utils/utils';

function OfferCard({ offer }) {
    return (
        <div className='w-[45%] h-auto rounded-3xl overflow-hidden shrink-0'>
            <img className='w-full h-auto' src={getCachedMediaUrl(offer.couponImage)} alt={offer.couponName} />
        </div>
    );
}

function OfferDisplay({ item }) {
    return (
        <div className='flex flex-col gap-3'>
            <p className='px-4 font-semibold text-[18px] leading-[30px] text-[#B0B0B0]'>{item.item.name}</p>

            <div className="px-4 w-full flex flex-nowrap gap-2 overflow-x-scroll no-scrollbar">
                {item.item.offersList?.map(offer => {
                    return (
                        <OfferCard 
                            key={offer.id} 
                            offer={offer} 
                        />
                    )
                })}
            </div>
        </div>
    );
}

export default OfferDisplay;
